import { render, staticRenderFns } from "./UserIdentify.vue?vue&type=template&id=3552e84a&"
import script from "./UserIdentify.vue?vue&type=script&lang=js&"
export * from "./UserIdentify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports